<form class="rcx-table" [formGroup]="separationForm">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="row g-3">
                <div class="col-md-3" *ngIf="separationType === 'TERMINATION'">
                  <label for="appliedFor" class="form-label">Employee Name</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="appliedForId"
                      placeholder="Select a employee" [readonly]="this.separation?.appliedForId"
                      [ngClass]="{'is-invalid': submitted && s.appliedForId.errors}">
                      <ng-option *ngFor="let applied of appliedFor" [value]="applied.employeeData?.id">
                        {{applied.employeeData?.name}}
                      </ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && s.appliedForId.errors">
                      <span *ngIf="s.appliedForId.required">Please select an employee</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="date" class="form-label">Applied On<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                        class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="appliedOn" formControlName="appliedOn"
                    [ngClass]="{'is-invalid': submitted && s.appliedOn?.errors}" readonly/>
                  </div>
                  <div
                    *ngIf="separationForm.get('appliedOn')?.invalid && (separationForm.get('appliedOn')?.dirty || separationForm.get('appliedOn')?.touched)">
                    <small class="text-danger" *ngIf="separationForm.get('appliedOn').errors?.required">Please select an
                      applied On</small>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="date" class="form-label">Last Working Day<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                        class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="lastWorkingDay" formControlName="lastWorkingDay"
                      [readonly]="this.separation?.lastWorkingDay" [ngClass]="{'is-invalid': submitted && s.lastWorkingDay?.errors}" />
                  </div>
                  <div
                    *ngIf="separationForm.get('lastWorkingDay')?.invalid && (separationForm.get('lastWorkingDay')?.dirty || separationForm.get('lastWorkingDay')?.touched)">
                    <small class="text-danger" *ngIf="separationForm.get('lastWorkingDay').errors?.required">Please
                      select an last working day.</small>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="status" class="form-label">Status</label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bxs-user-account'></i></span>
                    <input type="text" class="form-control ps-1" id="status" placeholder="Enter the status" readonly
                      [ngClass]="{'is-invalid': submitted && s.status?.errors}" formControlName="status"
                      autocomplete="off" [value]="separation?.status" />
                    <div
                      *ngIf="separationForm.get('status')?.invalid && (separationForm.get('status')?.dirty || separationForm.get('status')?.touched)">
                      <small class="text-danger" *ngIf="separationForm.get('status').errors?.required">Please enter the
                        status.</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="reason" class="form-label">Reason<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="reason" placeholder="Enter the reason"
                      [ngClass]="{'is-invalid': submitted && s.reason?.errors}" formControlName="reason"
                      autocomplete="off" [readonly]="this.separation?.reason" [value]="separation?.reason" />
                  </div>
                  <div
                    *ngIf="separationForm.get('reason')?.invalid && (separationForm.get('reason')?.dirty || separationForm.get('reason')?.touched)">
                    <small class="text-danger" *ngIf="separationForm.get('reason').errors?.required">Please enter the
                      reason.</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="remarks" class="form-label">Remarks<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bxs-user-account'></i></span>
                    <input type="text" class="form-control ps-1" id="remarks" placeholder="Enter the remarks"
                      [readonly]="this.separation?.remarks" [ngClass]="{'is-invalid': submitted && s.remarks?.errors}"
                      formControlName="remarks" autocomplete="off" [value]="separation?.remarks" />
                  </div>
                  <div
                    *ngIf="separationForm.get('remarks')?.invalid && (separationForm.get('remarks')?.dirty || separationForm.get('remarks')?.touched)">
                    <small class="text-danger" *ngIf="separationForm.get('remarks').errors?.required">Please enter the
                      remarks.</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>